import useAsyncCampaignNotifications from "./useAsyncCampaignNotifications/useAsyncCampaignNotifications";
import useCampaignBudgetNotifications from "./useCampaignBudgetNotifications";
import useCampaignEndNotifications from "./useCampaignEndNotification";
import useLineitemEndNotifications from "./useLineitemEndNotifications";
import useLineitemSpendNotifications from "./useLineitemSpendNotifications";

function useNotifications() {
  const lineitemEndNotifications = useLineitemEndNotifications();
  const asyncCampaignNotifications = useAsyncCampaignNotifications();
  const lineitemSpendNotifications = useLineitemSpendNotifications();

  // Campaign budget notifications
  const campaignBudgetNotifications = useCampaignBudgetNotifications();

  // Campaign end notifications
  const campaignEndNotifications = useCampaignEndNotifications();

  const notifications = lineitemEndNotifications
    .concat(asyncCampaignNotifications)
    .concat(lineitemSpendNotifications)
    .concat(campaignBudgetNotifications)
    .concat(campaignEndNotifications);

  return notifications;
}

export default useNotifications;
